<h2>{{ i18n.str('challengeu.mp_rooms_create', "CREATE NEW ROOM")() }}</h2>
<br><br>
<div class="flip">
  <div class="flip-inner" [class.flipped]="showCode">
    <div class="flip-front">
      <input type="text" [(ngModel)]="roomName" [maxlength]="128" placeholder="{{ i18n.str('challengeu.mp_rooms_what_name', 'Type the name of a European Capital City. Ex: Paris')() }}" (ngModelChange)="filterRooms()">
      @if (suggestions.length) {
        <div class="suggestions-list">
          @for (item of suggestions; track item) {
            <p class="jeopardy-button secondary" [class.success]="selectedRoom?.roomName === item.roomName" style="margin-top: 1em;">
              <a href="#" (click)="selectRoom($event, item)">{{ item.roomName }}</a>
            </p>
          }
        </div>
      }

      <h3>{{ i18n.str('challengeu.mp_rooms_select_no_players', 'Select the number of players')() }}</h3>
      <ul style="list-style-type: none;">
        <li class="number-box" [class.selected]="playersNumber === 2">
          <a class="neon" href="#" (click)="selectPlayersNumber($event, 2)">2</a>
        </li>
        <li class="number-box" [class.selected]="playersNumber === 3">
          <a href="#" (click)="selectPlayersNumber($event, 3)">3</a>
        </li>
        <li class="number-box" [class.selected]="playersNumber === 4">
          <a href="#" (click)="selectPlayersNumber($event, 4)">4</a>
        </li>
      </ul>
      <br><br>
      <h3>
        <input type="checkbox" [(ngModel)]="privateRoom">
        {{ i18n.str('challengeu.mp_rooms_make_private', 'Wish to make it private?')() }}
      </h3>


      <p class="jeopardy-button primary" style="margin-top: 1em;" [class.disabled]="!selectedRoom || roomIsCreated">
        <a href="#" (click)="createRoom($event)">{{ i18n.str('challengeu.mp_create', 'CREATE')() }}</a>
      </p>

      <p class="jeopardy-button secondary" style="margin-top: 1em;">
        <a href="#" routerLink="/main-menu">{{ i18n.str('challengeu.mp_back_main_menu', "BACK TO MAIN MENU")() }}</a>
      </p>
    </div>
    @if (showCode) {
      <div class="flip-back">
        <h3>{{ i18n.str('challengeu.mp_access_code', "Access code")() }}:</h3>
        <div>
          <input class="code-input" type="text" [(ngModel)]="accessCode">
        </div>
        <p class="warning-message">{{ i18n.str('challengeu.mp_share_warning', 'Please note down this code and share it only with your friends.')() }}</p>
        <p class="jeopardy-button primary" style="margin-top: 1em;margin-right: 1em;">
          <a href="#" (click)="copyCode($event)">{{ i18n.str('challengeu.mp_copy_code', 'Copy code')() }}</a>
        </p>
        <p class="jeopardy-button primary" style="margin-top: 1em;">
          <a href="#" (click)="goToLobby($event)">{{ i18n.str('challengeu.mp_go_to_room', 'Go to room')() }}</a>
        </p>
      </div>
    }
  </div>
</div>

<!-- <input type="text" placeholder="{{ i18n.str('challengeu.mp_rooms_give_password', 'GIVE A PASSWORD')() }}"> -->
<!-- <p class="warning-message">{{ i18n.str('challengeu.mp_create_warning_password', 'This room can be locked by the password. Share it only with your friends.')() }}</p> -->
